import React from 'react';
import { Checkbox, FormControlLabel, Link } from '@mui/material';
import legal from '../../config/legal.json';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  language?: 'en' | 'ar';
}

export default function SignupConsent({ checked, onChange, disabled, language }: Props) {
  const arabic = language === 'ar' || (!language && typeof window !== 'undefined' &&
    (document.documentElement.lang.startsWith('ar') || new URLSearchParams(window.location.search).get('lang') === 'ar'));
  const label = legal.signupAgreement[arabic ? 'ar' : 'en'];
  return (
    <FormControlLabel
      control={<Checkbox
        name="signupAgreement"
        required
        inputProps={{ 'aria-label': label }}
        checked={checked}
        disabled={disabled}
        onChange={event => onChange(event.target.checked)}
      />}
      label={<span lang={arabic ? 'ar' : 'en'} dir={arabic ? 'rtl' : 'ltr'}>
        {arabic ? 'عمري 18 سنة أو أكثر، وأوافق على ' : "I'm 18 or older and agree to the "}
        <Link href={legal.termsUrl} target="_blank" rel="noopener noreferrer" onClick={event => event.stopPropagation()}>
          {arabic ? 'الشروط' : 'Terms'}
        </Link>
        {arabic ? ' و' : ' and '}
        <Link href={legal.privacyUrl} target="_blank" rel="noopener noreferrer" onClick={event => event.stopPropagation()}>
          {arabic ? 'سياسة الخصوصية' : 'Privacy Policy'}
        </Link>
      </span>}
    />
  );
}
